// src/views/kiddo-games/drag-letters/components/LetterDropZone.tsx
// Kopia src/views/drag-letters/components/LetterDropZone.tsx (oryginał z Regular usunięty) — tylko dla Ułóż słowa Easy
/* eslint-disable react/no-unused-prop-types */
import React, { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';
import classes from '../KiddoDragLettersView.module.less';

interface LetterDropZoneProps {
  letter: string;
  showFeedback: boolean;
  isCorrect?: boolean;
  index: number;
}

export const LetterDropZone = memo(
  forwardRef<HTMLDivElement, LetterDropZoneProps>(
    ({
      letter, showFeedback, isCorrect, index,
    }, ref) => {
      const { t } = useTranslation();
      let className = classes.letterDropZone;

      if (showFeedback && isCorrect !== undefined) {
        className += isCorrect ? ` ${classes.correct}` : ` ${classes.incorrect}`;
      }

      return (
        <div
          ref={ref}
          className={className}
          data-slot-index={index}
          aria-label={t('games:labels.letterSlot', { n: index + 1 })}
        >
          {letter || '_'}
        </div>
      );
    },
  ),
);
